module.exports = __webpack_public_path__ + "img/game.933a06ff.png";